
define('template!webshopLandingpagesListCategoryView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="category-select-region"></div>';

}
return __p
};});

